import { TASK_STATUSES_DESC, TASK_STATUSES } from '@/config/constants';

const tasksColumns = {
  id: {
    key: 'id',
    label: 'id',
    type: 'text',
    sortable: true,
    minWidth: 30,
  },
  type: {
    key: 'type',
    label: 'taskType',
    type: 'enum',
    enum: 'taskTypes',
    sortable: false,
  },
  status: {
    key: 'status',
    label: 'status',
    type: 'encoded',
    sortable: false,
    customClass: true,
    enum: 'taskStatuses',
    decode: (value) => TASK_STATUSES_DESC[value],
    getClassModifier: (value) => TASK_STATUSES_DESC[value],
    minWidth: 50,
  },
  completed: {
    key: 'completed',
    label: 'completed',
    type: 'datetime',
    sortable: 'custom',
  },
  data: {
    key: 'data',
    label: 'data',
    type: 'text',
    sortable: false,
  },
  lastError: {
    key: 'lastError',
    label: 'lastError',
    type: 'text',
    sortable: false,
  },
  actions: {
    key: 'actions',
    label: 'actions',
    type: 'actions',
    sortable: false,
    minWidth: 30,
    fixed: true,
    buttons: [
      {
        name: 'restart',
        icon: 'fas fa-repeat',
        permission: ['tasksManage'],
        showCondition: (row) => row.status === TASK_STATUSES.Failed,
      },
    ],
  },
};

export default tasksColumns;
